import type { ReactNode } from "react";

/*
 * Break glass — the two paragraph styles inside a question bubble's tooltip,
 * re-exported from QuestionBubble as QuestionBubbleLabel / QuestionBubbleHeader.
 *
 * They mirror the `T` pair that tooltips built directly on ui-core's `Tooltip`
 * use — a bold title over `size="xs" color="secondary"` copy. Keep the two in
 * step: a help bubble should look the same whichever way it happens to be
 * written.
 *
 * Both are block-level copy carrying their own bottom margin, and that's the
 * part ui-core can't express: `T` renders a `<span>` with no `as`/`block` escape,
 * and spacing deliberately lives on `Stack`/`Row` rather than on text. Normally
 * that's right — but callers stack these across a module boundary, passing
 * `<><QuestionBubbleHeader/><QuestionBubbleLabel/><QuestionBubbleLabel/></>` as
 * one `description` prop, so there is no shared parent to own a gap. Until
 * ui-core's `T` can render as a block, the margin has to sit on the element.
 */

export function QuestionBubbleLabelBlock({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div className="mb-[7px] text-xs text-content-secondary">{children}</div>
  );
}

export function QuestionBubbleHeaderBlock({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div className="mb-3 text-sm font-bold text-foreground">{children}</div>
  );
}
